import {usePlantStartOfToday, useUpmPlantContext} from '@hconnect/upm'
import {Moment} from 'moment-timezone'

import {mapMaterialOrdersToIncomingMaterial} from '../selectors/materialOrders'

import {useMaterialOrdersQuery} from './useMaterialOrdersQuery'
import {useUnplannedDeliveriesQuery} from './useUnplannedDeliveriesQuery'

interface IncomingMaterialsQueryParams {
  materialId: number
  timeframe: [Moment, Moment] | undefined
}

export const useIncomingMaterialsQuery = ({
  materialId,
  timeframe
}: IncomingMaterialsQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()
  const startOfToday = usePlantStartOfToday()

  const [start, end]: (Moment | undefined)[] = timeframe ?? []
  const isTimeframeReady = Boolean(timeframe)

  const {data: unplannedDeliveries} = useUnplannedDeliveriesQuery({
    plantCode,
    materialId,
    from: start?.toISOString(),
    to: end?.toISOString(),
    options: {enabled: isTimeframeReady}
  })

  const isEnabled = isTimeframeReady && Boolean(unplannedDeliveries)

  return useMaterialOrdersQuery({
    plantCode,
    materialId,
    from: start?.toISOString(),
    to: end?.toISOString(),
    options: {
      enabled: isEnabled,
      select: (materialOrders) => {
        const ordersForMaterial = materialOrders.filter((order) => order.materialId === materialId)

        return unplannedDeliveries
          ? mapMaterialOrdersToIncomingMaterial(
              startOfToday,
              ordersForMaterial,
              unplannedDeliveries
            )
          : undefined
      }
    }
  })
}
